import { render, staticRenderFns } from "./home_article.vue?vue&type=template&id=6308e03c&scoped=true"
import script from "./home_article.vue?vue&type=script&lang=js"
export * from "./home_article.vue?vue&type=script&lang=js"
import style0 from "./home_article.vue?vue&type=style&index=0&id=6308e03c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6308e03c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6308e03c')) {
      api.createRecord('6308e03c', component.options)
    } else {
      api.reload('6308e03c', component.options)
    }
    module.hot.accept("./home_article.vue?vue&type=template&id=6308e03c&scoped=true", function () {
      api.rerender('6308e03c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/home_article.vue"
export default component.exports